"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ARIA_1 = tslib_1.__importDefault(require("./ARIA"));
class DOM {
    static getNthChild(element, index) {
        let count = 0, child = element.firstChild;
        while (child) {
            if (child.nodeType === 1) {
                if (index === count) {
                    return child;
                }
                ++count;
            }
            child = child.nextSibling;
        }
    }
    static getChildCount(element) {
        let count = 0, child = element.firstChild;
        while (child) {
            if (child.nodeType === 1) {
                ++count;
            }
            child = child.nextSibling;
        }
        return count;
    }
    static insertChild(parent, toAdd, index) {
        let count = 0, child = parent.firstChild, before = null;
        while (child) {
            if (child.nodeType === 1) {
                if (count === index) {
                    before = child;
                    break;
                }
                ++count;
            }
            child = child.nextSibling;
        }
        parent.insertBefore(toAdd, before);
    }
    static insertElementAfter(newElement, referenceElement) {
        if (!referenceElement.parentElement) {
            return;
        }
        referenceElement.parentElement.insertBefore(newElement, referenceElement.nextElementSibling);
    }
    static indexOf(container, toFind) {
        return Array.from((container.children || [])).indexOf(toFind);
    }
    static createDiv() {
        return document.createElement("div");
    }
    static createSpan() {
        return document.createElement("span");
    }
    static createTR() {
        return document.createElement("tr");
    }
    static isAttachedToDOM(element) {
        return document.body.contains(element);
    }
    static isVisibleInDOM(element) {
        return element.offsetParent !== null;
    }
    static isTabbable(element) {
        return element.tabIndex !== -1;
    }
    static findAllOverflowAncestors(element) {
        const relevantElements = [];
        while (element.parentElement) {
            element = element.parentElement;
            const elementStyle = window.getComputedStyle(element);
            if (/auto|scroll/.test(`${elementStyle.overflow}${elementStyle.overflowX}${elementStyle.overflowY}`)) {
                relevantElements.push(element);
            }
        }
        return relevantElements;
    }
    static isElementFullyVisible(element) {
        const relevantAncestors = DOM.findAllOverflowAncestors(element);
        const rect = element.getBoundingClientRect();
        for (const relevantAncestor of relevantAncestors) {
            const relevantAncestorRect = relevantAncestor.getBoundingClientRect();
            const isInsideAncestor = rect.left > relevantAncestorRect.left &&
                rect.bottom < relevantAncestorRect.bottom &&
                rect.top > relevantAncestorRect.top &&
                rect.right < relevantAncestorRect.right &&
                rect.right < (relevantAncestorRect.left + relevantAncestor.clientWidth); // Make sure it's not outside the width of the ancestor
            if (!isInsideAncestor) {
                return false;
            }
        }
        const bodyRectangle = document.body.getBoundingClientRect();
        return rect.left > 0 &&
            rect.bottom < bodyRectangle.bottom &&
            rect.top > 0 &&
            rect.right < bodyRectangle.right &&
            rect.right < document.body.clientWidth;
    }
    static setElementTabbable(element, tabbable) {
        element?.setAttribute("tabindex", tabbable ? "0" : "-1");
    }
    static setElementEnabled(element, enabled) {
        element?.classList.toggle("disabled", !enabled);
        element?.toggleAttribute("disabled", !enabled);
        element?.removeAttribute(ARIA_1.default.DISABLED);
        if (!enabled) {
            element?.setAttribute(ARIA_1.default.DISABLED, "true");
        }
    }
}
exports.default = DOM;
//# sourceMappingURL=DOM.js.map